<template>
<div class="chapter">
<div class="inner_page">
<div id="Splash.html" xml:lang="en-US">
<div class="Basic-Text-Frame-3">
<p class="quote2"><span class="quote-small-caps" style="font-size:1.1em;">Live each season</span><span class="quote-small-caps"> </span>as it passes; breathe the air, drink the drink, taste the fruit, and resign yourself to the influences of each.</p>
<p class="quotee2">Henry David Thoreau </p>
<p class="swoosh"><img alt="238.jpg" class="image" src="images/238.jpg" width="10%"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Splash.vue?d1703128